import { concat, not, any, propEq, filter, complement } from 'ramda'

import toInteger from '@/utils/to-integer'

import { Landlord } from '../types'

const isPrimary = propEq('primary', true)

export const findPrimaryLandlord = filter(isPrimary)

export const findSecondaryLandlords = filter(complement(isPrimary))

export const formatLandlordData = ({
  listingId,
  userId,
  primaryLandlord,
  secondaryLandlords
}: {
  listingId: string
  userId: string
  primaryLandlord: Landlord[]
  secondaryLandlords: Landlord[]
}) => {
  const landlordData = concat(primaryLandlord, secondaryLandlords)
  const removedSelfFromListing = not(any(propEq('id', userId), landlordData))
  const formattedLandlordData = {
    listing_id: listingId,
    primary_user_id: toInteger(findPrimaryLandlord(landlordData)[0].id),
    listing_landlords: landlordData.map(landlord => toInteger(landlord.id))
  }
  return { formattedLandlordData, removedSelfFromListing }
}
